var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/binder"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.004 6.279A5.5 5.5 0 0 1 18 6.5V18a.5.5 0 1 1-1 0V6.5l-.005-.212A4.5 4.5 0 0 0 8 6.5V19a3.5 3.5 0 0 0 6.995.192L15 19v-8.5l-.005-.164A2.5 2.5 0 0 0 10 10.5V17a.5.5 0 1 1-1 0v-6.5l.005-.192A3.5 3.5 0 0 1 16 10.5V19a4.5 4.5 0 0 1-8.995.212L7 19V6.5z",
    className: "primarytint"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinder);
export default __webpack_public_path__ + "static/media/binder.db6a38143dc860afd9816126aebf5a96.svg";
export { ForwardRef as ReactComponent };